// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__0b53H","footer__infolinks":"Footer_footer__infolinks__s0eBa"};